import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  deletePreReq,
  patchPreReqStatus,
  updatePreReq,
  insertPreReq,
} from "../../../../../store/ictPreReqSlice";
const user = JSON.parse(localStorage.getItem("user"));
const username = user?.username || null;
const userRole = user?.role || null;
const isReadOnly = userRole === "sales";

const PreReqPopup = ({ ictId, preReqs = [], onClose, showInsertForm = false }) => {
  const dispatch = useDispatch();

  const [editItemId, setEditItemId] = useState(null);
  const [editDesc, setEditDesc] = useState("");
  const [newDesc, setNewDesc] = useState("");

  const handleDelete = (id) => {
    if (window.confirm("Are you sure you want to delete this prerequisite?")) {
      dispatch(deletePreReq(id));
    }
  };

  const handleStatusToggle = (item) => {
    const newStatus = item.status === "A" ? "D" : "A";
    dispatch(patchPreReqStatus({ pr_id: item.id, status: newStatus }));
  };

  const handleEdit = (item) => {
    setEditItemId(item.id);
    setEditDesc(item.prDesc);
  };

  const handleSave = (item) => {
    dispatch(updatePreReq({ id: item.id, prDesc: editDesc }));
    setEditItemId(null);
    setEditDesc("");
  };

  const handleInsert = () => {
    if (newDesc.trim()) {
      dispatch(insertPreReq({ ictId_id: parseInt(ictId), prDesc: newDesc, status: "A" }));
      setNewDesc("");
      onClose(); // optional: close popup after insert
    }
  };

  return (
    <div className="popup-overlay">
      <div className="popup-content large">
        <div className="popup-header">
          <h3>{showInsertForm ? "Add Prerequisite" : `Pre-requisites for ICT ID: ${ictId}`}
            <button className="close-btn" onClick={onClose}>
                <i className="fa fa-times"></i>
            </button>
          </h3>
        </div>

        {showInsertForm ? (
          <div>
            <div className="form-group">
            <textarea
              placeholder="Type prerequisite here..."
              value={newDesc}
              cols={50}
              rows={5}
              onChange={(e) => setNewDesc(e.target.value)}
            />
            </div>
            <hr/>
            <button onClick={handleInsert}>
                Insert 
            </button>
          </div>
        ) : (
          <>
            {preReqs.length === 0 ? (
              <p>No pre-requisites found.</p>
            ) : (
              <table className="table styled-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Description</th>
                    <th>Status</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {preReqs.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        {editItemId === item.id ? (
                          <input
                            type="text"
                            value={editDesc}
                            onChange={(e) => setEditDesc(e.target.value)}
                          />
                        ) : (
                          item.prDesc
                        )}
                      </td>
                      <td>
                        <label className="switch">
                          <input
                            type="checkbox"
                            checked={item.status === "A"}
                            onChange={() => handleStatusToggle(item)}
                          />
                          <span className="slider round"></span>
                        </label>
                      </td>
                      <td>
                        {!isReadOnly && editItemId === item.id ? (
                          <i
                            className="fa fa-save action-icon saveIcon"
                            onClick={() => handleSave(item)}
                          ></i>
                        ) : (
                        <>
                          {!isReadOnly && (
                            <i
                              className="fa fa-edit action-icon editIcon"
                              onClick={() => handleEdit(item)}
                            ></i>
                          )}
                        </>
                        )}
                        {!isReadOnly && ( <i
                          className="fa fa-trash action-icon deleteIcon"
                          onClick={() => handleDelete(item.id)}
                        ></i>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default PreReqPopup;
